<template>
  <div>
    <div class="switch__container"
         :style="{
            width: containerWidth + 'px'
         }"
         :class="disabled ? 'switch__disabled' : ''">
      <div class="switch__item"
           v-for="item in switchArray"
           :key="item.id">
        <input type="radio"
               :id="item.value"
               :name="item.groupName"
               :checked="item.selected"
               :disabled="item.disabled">
        <label class="switch__label"
               :class="{ 'switch__label--active': activeSwitch === item.value}"
               :for="item.value"
               @click="[updateSwitch(item), activeSwitch = item.value]">
          <span class="switch__text">{{ item.label }}</span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'SwitchButton',
    props: {
      switchArray: Array,
      containerWidth: Number,
      disabled: Boolean
    },
    data () {
      return {
        isActive: true,
        activeSwitch: ''
      }
    },
    methods: {
      updateSwitch (item) {
        let self = this

        if(!self.disabled) {
          self.$emit('updateSwitch', { selectedItem: item })
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../styling/styling.scss';

  [type="radio"]:checked,
  [type="radio"]:not(:checked) {
    left: rem(-9999);
    position: absolute;
  }

  [type="radio"]:checked + label,
  [type="radio"]:not(:checked) + label {
    width: 100%;
    height: rem(25);
    float: left;
    cursor: pointer;
    font-weight: 400;
    position: relative;
    text-align: center;
    font-size: rem(13);
    line-height: rem(23);
    display: inline-block;
    color: $medium-grey-font;
    border: rem(1) solid $dark-grey-background;
  }

  [type="radio"]:checked + label {

    &:hover {
      background-color: $pending-blue;

      .switch__text { color: $white; }
    }
  }

  [type="radio"]:checked + label:before,
  [type="radio"]:not(:checked) + label:before {
    width: calc(100% - #{rem(-1)});
    height: rem(25);
    top: 0;
    left: 0;
    content: '';
    z-index: -2;
    position: absolute;
    background: $white;
  }

  [type="radio"]:checked + label:after,
  [type="radio"]:not(:checked) + label:after {
    width: 100%;
    min-width: rem(75);
    height: rem(25);
    top: 0;
    left: 0;
    content: '';
    z-index: -1;
    position: absolute;
    background: $pending-blue;
  }

  [type="radio"]:not(:checked) + label:after { opacity: 0; }

  [type="radio"]:checked + label { color: $white; }

  [type="radio"]:checked + label:after { opacity: 1; }

  .switch {

    &__container {
      width: 100%;
      display: table;
      table-layout: fixed;
      padding-left: rem(1);
    }

    &__text {
      width: 100%;
      max-width: rem(128);
      overflow: hidden;
      padding: 0 rem(10);
      text-align: center;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    &__item {
      height: rem(25);
      border-left: 0;
      display: table-cell;
      margin-left: rem(-1);

      .switch__label { border-left: 0!important; }

      &:first-child {
        margin-left: 0;

        .switch__label {
          border-top-left-radius: rem(2);
          border-bottom-left-radius: rem(2);
          border-left: rem(1) solid $dark-grey-background !important;

          &:after {
            border-top-left-radius: rem(2);
            border-bottom-left-radius: rem(2);
          }

          &:after, &:before { height: rem(25); }

          &:after {
            left: 0;
            top: rem(-1);
          }
        }
      }

      &:last-child {

        .switch__label {
          border-top-right-radius: rem(2);
          border-bottom-right-radius: rem(2);

          &:after {
            border-top-right-radius: rem(2);
            border-bottom-right-radius: rem(2);
          }

          &:after, &:before { height: rem(25); }

          &:after {
            left: 0;
            top: rem(-1);
          }
        }
      }
    }

    &__label {
      overflow: hidden;
      white-space: nowrap;
      margin-left: rem(-1);
      text-overflow: ellipsis;
      color: $medium-grey-font;

      &:hover {
        background-color: $medium-grey-background;

        .switch__text { color: $dark-grey-font; }
      }

      &--active {
        border: rem(1) solid $pending-blue!important;

        .switch__text { color: $white; }

        &:hover {
          background-color: $pending-blue;

          .switch__text { color: $white; }
        }
      }
    }

    &__disabled {
      position: relative;

      .switch__label {
        color: $dark-grey-background !important;
        border-color: $dark-grey-background !important;
      }

      &:after {
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        content: '';
        position: absolute;
      }

      &:hover { cursor: not-allowed; }
    }
  }
</style>



// WEBPACK FOOTER //
// node_modules/pro4all-ui/ui-kit/components/Switch.vue